const i18n = {
  'form': {
    'field': {
      'isRequired': '欄位為必填',
      'notZero': '不可為零',
      'ratioError': '營收占比不得大於100%'
    },
    'businessNumber': {
      'lengthError': '統一編號長度錯誤',
      'validateError': '統一編號驗證錯誤',
    },
    'mobile': {
      'lengthError': '手機號碼長度錯誤',
      'formatError': '電話號碼格式錯誤',
    },
    'basicPurchaseAmount': {
      'lowerThanBasicPurchaseAmount': '低於最低採購金額'
    },
    'freeShippingAmount': {
      'lowerThanFreeShippingAmount': '低於免運金額'
    },
    'invoiceNumber': {
      'formatError': '發票號碼長度錯誤'
    },
    'date': {
      'formatError': '無效的日期格式',
      'beforeStartDate': '日期不得小於開始日期',
      'afterEndDate': '日期不得大於結束日期',
      'afterToday': '日期不得大於今日',
      'beforeToday': '日期不得早於今日',
    },
    'amount': {
      'overRequire': ' 超過需求數量'
    },
    'customer': {
      'error': '套裝療程客戶不得與療程客戶不同'
    },
    'package': {
      'error': '必須包含療程',
      'ratioError': '總營收占比不得大於100%'
    }
  }
}
export default i18n
